import { useCallback } from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

export function useLightboxBackgroundClose() {
  const elementContext = useModalElementContext()

  return useCallback((event: React.MouseEvent<HTMLElement>) => {
    if (event.target === event.currentTarget) {
      event.stopPropagation()
      elementContext?.resolve()
    }
  }, [elementContext])
}
